import { baseQueryParams } from 'src/utils';
import { getKeyByValue } from './getKeyByValue';

type MapFiltersToUrlParams = {
  value: string | number;
  param: string;
  activeFilters?: Record<keyof typeof baseQueryParams, '' | string>;
};

/**
 * Checks if the checkbox is checked
 * @param value - The value of the checkbox
 * @param param - The param of the filter
 * @param activeFilters - The active filters
 * @returns true if the checkbox is checked, false otherwise
 */
export const isChecked = ({ value, param, activeFilters }: MapFiltersToUrlParams): boolean => {
  const paramKey = getKeyByValue(baseQueryParams, param);

  for (const urlParam in activeFilters) {
    const currentUrlParam = urlParam as keyof typeof baseQueryParams;

    if (currentUrlParam === paramKey && activeFilters[currentUrlParam]) {
      const filter = activeFilters[currentUrlParam];
      const selectedOptions = filter.length ? filter.split(',') : [];
      const isActive = selectedOptions.find((option) => option === value);

      return Boolean(isActive);
    }
  }

  return false;
};
